"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
const isUserAgent_1 = require("./isUserAgent");
exports.isBrowser = {
    Chrome: () => (0, isUserAgent_1.isUserAgent)(/chrome|chromium|crios/i),
    Safari: () => (0, isUserAgent_1.isUserAgent)(/^((?!chrome|android).)*safari/i),
    Firefox: () => (0, isUserAgent_1.isUserAgent)(/firefox|fxios/i),
    Opera: () => (0, isUserAgent_1.isUserAgent)(/opr\//i),
    Edge: () => (0, isUserAgent_1.isUserAgent)(/edg/i),
    any: () => exports.isBrowser.Chrome() ||
        exports.isBrowser.Safari() ||
        exports.isBrowser.Firefox() ||
        exports.isBrowser.Opera() ||
        exports.isBrowser.Edge(),
};
